import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Autocomplete, TextField, IconButton } from '@totalsoft/rocket-ui';
import Search from '@mui/icons-material/Search';
import Close from '@mui/icons-material/Close';

const OfferPartnerVerificationToolbar = React.memo(
  ({
    onResetFilters,
    onFilterValueChanged,
    fullTextFilter,
    onVerificationSorterChanged,
    verificationSorterOptions,
    selectedVerificationOrder
  }) => {
    const [t] = useTranslation();

    const resetFilters = () => onResetFilters();
    const onTextFilterChanged = () => value => onFilterValueChanged(value, true);

    return (
      <Grid container spacing={2} px={1} mb={2}>
        <Grid item container xs={6} alignItems='end' gap={1}>
          <Search />
          <Grid item flexGrow={1}>
            <TextField
              id={'offerPartnerVerificationCard_filters_fullText'}
              fullWidth={true}
              name='fullTextFilter'
              value={fullTextFilter}
              onChange={onTextFilterChanged('fullTextFilter')}
              label={t('Placeholders.VerificationSearch')}
              endAdornment={
                <IconButton
                  onClick={resetFilters}
                  color='primary'
                  variant='text'
                  size='tiny'
                  tooltip={t('Tooltips.ResetFilters')}
                  id={'offerPartnerVerificationCard_filters_resetBtn'}
                >
                  <Close />
                </IconButton>
              }
            />
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Autocomplete
            id={'verificationSorter'}
            label={t('General.OrderBy')}
            fullWidth
            value={selectedVerificationOrder.id}
            onChange={onVerificationSorterChanged}
            labelKey='name'
            valueKey='id'
            simpleValue={true}
            options={verificationSorterOptions}
            isClearable={false}
            isSearchable={false}
          />
        </Grid>
      </Grid>
    );
  }
);

OfferPartnerVerificationToolbar.displayName = 'OfferPartnerVerificationToolbar';

OfferPartnerVerificationToolbar.propTypes = {
  fullTextFilter: PropTypes.string.isRequired,
  onFilterValueChanged: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  onVerificationSorterChanged: PropTypes.func.isRequired,
  verificationSorterOptions: PropTypes.array.isRequired,
  selectedVerificationOrder: PropTypes.object.isRequired
};

export default OfferPartnerVerificationToolbar;
